import React from "react";
import { cn } from "@/lib/utils";

interface ContentBlockCardProps {
  children?: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  noPadding?: boolean;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  action?: React.ReactNode;
}

export function ContentBlockCard({
  children,
  title,
  description,
  className,
  noPadding = false,
  icon,
  badge,
  action,
}: ContentBlockCardProps) {
  return (
    <div
      className={cn(
        "bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow overflow-hidden",
        !noPadding && "p-6",
        className,
      )}
    >
      {(title || description || badge || action) && (
        <div className={cn(noPadding ? "px-6 pt-6 pb-4" : "mb-4")}>
          <div className="flex gap-3">
            {icon && (
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 border border-blue-200 dark:border-blue-700 flex items-center justify-center">
                  <span className="text-blue-600 dark:text-blue-400">
                    {icon}
                  </span>
                </div>
              </div>
            )}
            <div className="flex-1">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  {title && (
                    <h3 className="text-base font-medium mb-1">{title}</h3>
                  )}
                  {badge && <div className="mb-2">{badge}</div>}
                  {description && (
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {description}
                    </p>
                  )}
                </div>
                {action && <div className="ml-4 flex-shrink-0">{action}</div>}
              </div>
            </div>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
